/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Show Mobile Dialog Event Handler
 *
 * Shows a dialog informing the user that this feature may only be used
 * in the mobile application.
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {PlatformEvent} event             the event that triggered this handler
 */
const showMobileApplicationRequiredDialog = (module, component, event) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]

  eventBus.dispatch(eventBus.type(G.DATA, G.UNDO), {
    title: module[G.ADAPTER][G.INTL]._t(
      'dialog.mobileRequired.title',
      {
        ns: 'common',
        _key: 'dialog.mobileRequired.title',
        defaultValue: 'Sorry',
      },
    ),
    text: module[G.ADAPTER][G.INTL]._t(
      'dialog.mobileRequired.text',
      {
        ns: 'common',
        _key: 'dialog.mobileRequired.text',
        defaultValue: 'This feature is under development.',
      },
    ),
    children: {
      ok: {
        key: 'ok',
        value: module[G.ADAPTER][G.INTL]._t(
          'button.ok',
          {
            ns: 'common',
            _key: 'button.ok',
            defaultValue: 'Ok',
          },
        ),
      },
    },
  })
}

export default curry(showMobileApplicationRequiredDialog)
